import { auth, signInWithCustomToken } from '~providers/firebase'
import { RegisterMetadata } from '~types'
import { clientUnauthenticated as axios } from '~utils/fetch'

export default async function onGoogleButtonPress(
  idToken: string,
  metadata?: RegisterMetadata,
): Promise<void> {
  try {
    // Send ID token to api
    const res = await axios({
      url: '/api/v1/login/google',
      method: 'POST',
      data: {
        token: idToken,
        metadata: {
          ...(metadata ?? {}),
        },
      },
    })

    if (res.status === 200) {
      await signInWithCustomToken(auth, res.data.token)
    }
  } catch (error) {
    console.log(error)
  }
}
